import BackupPanel from "../../components/BackupPanel";

export default function Backup() {
  return (
    <div className="space-y-6" data-testid="page-backup">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Yedek Al</h1>
        <p className="text-sm text-slate-500 mt-1">Veritabanı yedeği alma ve geri yükleme işlemleri.</p>
      </div>
      <BackupPanel />
    </div>
  );
}
